/* @flow */
import gql from 'graphql-tag';
import {fragments as hitCollectionFragments} from '../components/HitCollection/HitCollection';
import {fragments as mapFragments} from '../components/Map/Map';
import {fragments as pagerFragments} from '../components/Pager/Pager';
import {fragments as destinationMessage} from '../components/SearchBannerContainer/destinationMessage';
import {fragments as filterCountsFragments} from '../../universal/queries/filteredCountQuery';
import {fragments as expandedGroupsFragments} from '../components/ExpandedGroups/ExpandedGroups';
import {fragments as analyticsDataLayerFragments} from '../components/AnalyticsDataLayer/AnalyticsDataLayer';
import {fragments as seoContentFragment} from '../components/SeoContent/SeoContent';
import transformSrsParamsToGts from '../../server/graphql/transformers/transformSrsParamsToGts';
import {srsParams as getSrsParams} from '../utils/searchParamsUtils';
import type {SearchParamsType} from '../reducers/searchParams';
import {querySelectionSet} from './searchQuery';

export const searchRequestQueryVariables = (params: SearchParamsType) => {
    const srsParams = getSrsParams(params);
    return {
        request: transformSrsParamsToGts(srsParams)
    };
};

export const SEARCH_REQUEST_QUERY_NAME = 'SearchRequestQuery';

const searchRequestQuery = gql`
    query ${SEARCH_REQUEST_QUERY_NAME}($request: SearchResultRequest!) {
        results: search(request: $request) {
            ${querySelectionSet}
            ...DestinationMessageSearchResult
            ...FilterCountsSearchResult
            ...HitCollectionSearchResult
            ...ADLSearchResult
            ...MapSearchResult
            ...ExpandedGroupsSearchResult
            ...PagerSearchResult
            ...SeoContentSearchResult
        }
        ...RequestMarkerFragment
    }
    ${hitCollectionFragments.searchResult}
    ${expandedGroupsFragments.searchResult}
    ${filterCountsFragments.searchResult}
    ${mapFragments.searchResult}
    ${pagerFragments.searchResult}
    ${destinationMessage.searchResult}
    ${analyticsDataLayerFragments.searchResult}
    ${analyticsDataLayerFragments.query}
    ${seoContentFragment.searchResult}
`;

export default searchRequestQuery;
